import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UnitInformationRoutingModule } from './unit-information-routing.module';
import { LookupComponent } from '../unit-information';
import { SharedModule } from '../shared/shared.module';
import { WardInformationComponent } from './ward-information/ward-information.component';
import { StakeInformationComponent } from './stake-information/stake-information.component';
import { LocalWardSelectionComponent } from './lookup/local-ward-selection/local-ward-selection.component';
import { HousingComplexSelectionComponent } from './lookup/housing-complex-selection/housing-complex-selection.component';
import { CampusUnitSelectionComponent } from './lookup/campus-unit-selection/campus-unit-selection.component';
import { UnitLeaderComponent } from './unit-leader/unit-leader.component';
import { UnitLoginComponent } from './unit-login/unit-login.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UnitInformationRoutingModule
  ],
  declarations: [
    LookupComponent,
    WardInformationComponent,
    StakeInformationComponent,
    LocalWardSelectionComponent,
    HousingComplexSelectionComponent,
    CampusUnitSelectionComponent,
    UnitLeaderComponent,
    UnitLoginComponent
  ]
})
export class UnitInformationModule { }
